export const API_CONSTANTS = {
    PAGE_SIZE: 10,
    PAGES: {
        TYPE: {
            0: 'HTML',
        },
    },
};
